import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#0517f8",
		fillRule: "evenodd",
		stroke: "#0517f8",
		strokeWidth: 1.2,
		d: "M4.866 11.828 2.64 13.407a.87.87 0 0 0-.322.985l.837 2.512c.117.356.45.596.825.596h2.78a.87.87 0 0 0 .825-.596l.837-2.512a.87.87 0 0 0-.322-.985l-2.226-1.58a.87.87 0 0 0-1.008 0Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#0517f8",
		fillRule: "evenodd",
		stroke: "#0517f8",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M3.495 2.917h3.75c.46 0 .834.373.834.833V7.5c0 .46-.374.833-.834.833h-3.75a.834.834 0 0 1-.833-.833V3.75c0-.46.373-.833.833-.833M14.694 11.667a2.917 2.917 0 1 0 0 5.833 2.917 2.917 0 0 0 0-5.833M13.838 3.392l-2.122 3.396a1.01 1.01 0 0 0 .856 1.545h4.246a1.01 1.01 0 0 0 .855-1.545l-2.121-3.396a1.01 1.01 0 0 0-1.714 0",
		clipRule: "evenodd"
	})]
});
export default SvgPartsActive;
